/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropparticipants1Inputs */

const en_dropparticipants1 = /** @type {(inputs: Dropparticipants1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participants`)
};

const de_dropparticipants1 = /** @type {(inputs: Dropparticipants1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmer`)
};

/**
* | output |
* | --- |
* | "Participants" |
*
* @param {Dropparticipants1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropparticipants1 = /** @type {((inputs?: Dropparticipants1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropparticipants1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropparticipants1(inputs)
	return de_dropparticipants1(inputs)
});
export { dropparticipants1 as "dropParticipants" }